<div class="container">
  <div class="row mt-5">
    <div class="col-md-12 text-center mt-5" style="font-size:1.4em; font-weight:bold; text-decoration:underline; color:red">
      Online Claims Filing Has Ended
    </div>
  </div>
</div>




<!--<div class="container">
  <div class="row mt-5">
    <div class="col-md-12 text-center" style="font-size:1.4em; font-weight:bold; text-decoration:underline">
      Colombo v. Nationstar Mortgage LLC CLAIM FORM
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <b>Claim forms must be submitted online by 12:00 a.m. (midnight) Eastern Standard Time on August 15, 2026.</b><br /><br />


      If you do not provide the correct information, your claim(s) may be denied and you will not get a payment.
    </div>
  </div>
  <div class="row lightgraybackground mt-4">
    <div class="col-md-12">
      CLAIMANT INFORMATION
    </div>
  </div>
  <div class="container">
    <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
      <div class="row mt-2">
        <div class="col-md-12">
          <b>Claim ID:</b> {{authenticatedUser.noticeId}}<br />
          <b>UniqueID:</b> {{authenticatedUser.uniqueId}}
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="name1">Full Name (First Name, Last Name):<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="name1" formControlName="name1" placeholder=""
                   autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': f.name1.errors && (f.name1.dirty || f.name1.touched || f.name1.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.name1" class="invalid-feedback">
              <div *ngIf="f.name1.hasError(validation.type) && (f.name1.dirty || f.name1.touched || f.name1.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="street1">Current Address (Street, PO Box, Suite, or Office Number):<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="street1" formControlName="street1" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.street1.errors && (f.street1.dirty || f.street1.touched || f.street1.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.street1" class="invalid-feedback">
              <div *ngIf="f.street1.hasError(validation.type) && (f.street1.dirty || f.street1.touched || f.street1.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="city">City:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="city" formControlName="city" placeholder="" autocomplete="off"
                   trim="blur" [ngClass]="{ 'is-invalid': f.city.errors && (f.city.dirty || f.city.touched || f.city.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.city" class="invalid-feedback">
              <div *ngIf="f.city.hasError(validation.type) && (f.city.dirty || f.city.touched || f.city.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <label class="titleBold" for="state">State:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': f.state.errors && (f.state.dirty || f.state.touched || f.state.pristine )}">
            <option value="">Please select a State</option>
            <option *ngFor="let allstate of allStates">
              {{allstate.Name}}
            </option>
          </select>
          <div *ngFor="let validation of validation_FormErrorMessages.state" class="invalid-feedback">
            <div *ngIf="f.state.hasError(validation.type) && (f.state.dirty || f.state.touched || f.state.pristine)">
              {{ validation.message }}
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="titleBold" for="zip">Zip Code:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="zip" formControlName="zip"
                   placeholder="Zip Code: (XXXXX or XXXXX-XXXX)" autocomplete="off" trim="blur"
                   [ngClass]="{ 'is-invalid': f.zip.errors && (f.zip.dirty || f.zip.touched || f.zip.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.zip" class="invalid-feedback">
              <div *ngIf="f.zip.hasError(validation.type) && (f.zip.dirty || f.zip.touched || f.zip.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="phone1">Phone Number:<span style="color:red" class="required"> *</span></label>
            <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="phone1" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                   [ngClass]="{ 'is-invalid': f.phone1.errors && (f.phone1.dirty || f.phone1.touched || f.phone1.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.phone1" class="invalid-feedback">
              <div *ngIf="f.phone1.hasError(validation.type) && (f.phone1.dirty || f.phone1.touched || f.phone1.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="titleBold" for="emailAddress">E-Mail Address:<span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors && (f.emailAddress.dirty || f.emailAddress.touched || f.emailAddress.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.emailAddress" class="invalid-feedback">
              <div *ngIf="f.emailAddress.hasError(validation.type) && (f.emailAddress.dirty || f.emailAddress.touched || f.emailAddress.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-md-12">
          You must provide a current, valid email address or mobile phone number on your claim form (if you have one). If the email address or mobile phone number you provide
          becomes invalid for any reason, it is your responsibility to provide updated contact information to the Settlement Administrator to receive your payment.
        </div>
      </div>


      <div class="row mt-4">
        <div class="col-md-12">
          <div class="form-group form-check">
            <input type="checkbox" formControlName="acknowledgement" class="form-check-input" trim="blur" [ngClass]="{ 'is-invalid': f.acknowledgement.errors && (f.acknowledgement.dirty || f.acknowledgement.touched || f.acknowledgement.pristine )}" />
            <label for="acknowledgement">
              <b>
                I verify that the foregoing is true and correct.
              </b>
            </label>
            <div *ngFor="let validation of validation_FormErrorMessages.acknowledgement" class="invalid-feedback">
              <div *ngIf="f.acknowledgement.hasError(validation.type) && (f.acknowledgement.dirty || f.acknowledgement.touched || f.acknowledgement.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-group">
            <label class="titleBold" for="signature">Electronic Signature: <span style="color:red" class="required"> *</span></label>
            <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                   trim="blur" [ngClass]="{ 'is-invalid': f.signature.errors && (f.signature.dirty || f.signature.touched || f.signature.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.signature" class="invalid-feedback">
              <div *ngIf="f.signature.hasError(validation.type) && (f.signature.dirty || f.signature.touched || f.signature.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': f.googleRecaptchaToken.errors && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched || f.googleRecaptchaToken.pristine )}" />
            <div *ngFor="let validation of validation_FormErrorMessages.googleRecaptchaToken" class="invalid-feedback">
              <div *ngIf="f.googleRecaptchaToken.hasError(validation.type) && (f.googleRecaptchaToken.dirty || f.googleRecaptchaToken.touched || f.googleRecaptchaToken.pristine)">
                {{ validation.message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <ul class="list-inline text-center">
        <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
      </ul>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Loading...</p>
    </ngx-spinner>
  </div>
</div>-->
